import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

const { TaxReport: { getTaxReport } } = apiUrls;

export const TAX_REPORT_SUCCESS = 'TAX_REPORT_SUCCESS';
export const TAX_REPORT_LOADING = 'TAX_REPORT_LOADING';

export const getTaxReportData = ({ fromdate, todate }) => async (dispatch) => {
    try {
        const { url } = getTaxReport
        const requestData = {
            ...getTaxReport,
            url: url.replace('{{fromdate}}', fromdate).replace('{{todate}}', todate)
        };
        const data = await REQUEST(requestData);
        dispatch({
            type: TAX_REPORT_SUCCESS,
            data,
        })

    } catch (e) {

        dispatch({
            type: TAX_REPORT_SUCCESS,
            data: {
                code: "",
                modal: null,
                notifications: null,
                paginationInfo: null
            }
        })
    }

}

export const handleLoader = isLoading => (dispatch) => {
    dispatch({
        type: TAX_REPORT_LOADING,
        isLoading
    });
}